export default __webpack_public_path__ + "static/media/AAC_white_trans.ba12cd7f.png";